import { Component } from '@angular/core';
import * as FileSaver from 'file-saver';
import dataConfig from '../../../../assets/program-shortcuts-data.json';
import { ApiService } from '../../../core/services/api.service';
import { LoaderService } from '../../../core/services/loading.service';




@Component({
    selector: 'app-program-shortcuts',
    templateUrl: './program-shortcuts.component.html',
    standalone: false
})
export class ProgramShortcutsComponent {
    programShortcutsData1: any[] = dataConfig.listConfig.dataSource1;
    programShortcutsData2: any[] = dataConfig.listConfig.dataSource2;
    programShortCutLinks: any;
    showDownload: boolean = false;
    showSoldProposals: boolean = false;
    showDraft: boolean = false;
    JSON = JSON;
    constructor(
        public apiService: ApiService, public loaderService: LoaderService,
    ) { }
    ngOnInit() {
        this.programShortCutLinks = JSON.parse(this.loaderService.getItem('programShortcuts'));
        if (this.programShortCutLinks['ACCOUNT POLICY DOWNLOAD']) {
            this.showDownload = true;
        }
        if (this.programShortCutLinks['SOLD PROPOSAL']) {
            this.showSoldProposals = true;
        }
        if (this.programShortCutLinks['DRAFT']) {
            this.showDraft = true;
        }
    }
    onPdfCellClicked() {
        const payload = {
            reportFormat: 'EXCEL',
            reportType: 'ACCOUNT_POLICY_DOWNLOAD',
            orgnztnId: this.loaderService.getItem('orgId'),
        };
        const endpoint = 'export';
        this.apiService?.postDataBlob(endpoint, payload,)?.subscribe({
            next: (response: any) => {
                this.loaderService.hideLoader();
                const blob = new Blob([response.body], { type: response.headers.get('content-type') });
                const fileName = `policyDetails.xls`;
                const file = new File([blob], fileName, { type: response.headers.get('content-type') });
                FileSaver.saveAs(file, `${fileName}`);

            },
        });
    }
}
